/* Cortazu static pages v2 (round 5, 22 Oct 2026). Loaded (defer) by sections/cz-page-*.liquid.
   1. Subtle scroll reveal: elements with [data-czp-reveal] get .is-in when they enter the viewport (IntersectionObserver).
      html.czp-js is set inline by the first section; with prefers-reduced-motion or without IntersectionObserver
      everything is shown at once. CSS has a failsafe animation, so content never stays hidden if this file fails.
   2. Map on the contact page: click-to-load (no Google request until the visitor asks for the map). */
(function () {
  'use strict';
  if (window.czpPagesInit) return;
  window.czpPagesInit = true;
  var d = document;
  d.documentElement.classList.add('czp-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = [].slice.call(d.querySelectorAll('[data-czp-reveal]:not(.is-in)'));
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  function maps() {
    [].forEach.call(d.querySelectorAll('[data-czp-map]'), function (m) {
      var btn = m.querySelector('[data-czp-map-load]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var f = d.createElement('iframe');
        f.src = m.getAttribute('data-czp-map');
        f.title = m.getAttribute('data-czp-map-title') || 'Map';
        f.loading = 'lazy';
        f.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
        f.setAttribute('allowfullscreen', '');
        m.querySelector('.czp-map__frame').appendChild(f);
        m.classList.add('is-loaded');
        btn.remove();
      });
    });
  }

  function init() { reveal(); maps(); }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
